/* unplugin-vue-components disabled */import script from "./certificateGet.vue?vue&type=script&lang=ts&setup=true"
export * from "./certificateGet.vue?vue&type=script&lang=ts&setup=true"

import "./certificateGet.vue?vue&type=style&index=0&id=2539b6cd&lang=less"

export default script